import { render, staticRenderFns } from "./PositionTestResultPage.vue?vue&type=template&id=09507390&scoped=true&"
import script from "./PositionTestResultPage.vue?vue&type=script&lang=js&"
export * from "./PositionTestResultPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09507390",
  null
  
)

export default component.exports